module.exports = {
  GuideMultiInput: {
    PluginName: "Screen Training Multi-Input",
    EmptyHint: "Screen Training Multi-Input area — add items from the toolbar",
    Items: "Items",
    ItemCount: "Item Count",
    placeholder: "Type here…",
    add_tag: "Add Tag",
    kind_tag: "Tag",
    tag_ref: "Tag Reference",
    tag_ref_placeholder: "e.g. firstName",
    behavior_title: "Behavior",
    auto_advance: "Advance scene when all steps are done",
    cue_beacon: "Pulsing highlight on the active step",
    cue_cursor: "Guide cursor moves to the active step",
    cue_backdrop: "Dim the screen around the active step",
    zoom_enabled: "Zoom to the active step",
  },
};
